import * as actionTypes from './actionTypes';

export const search = (key, queryParams = {}) => ({
  type: actionTypes.SEARCH,
  key,
  queryParams,
});
export const searchSuccess = (results, facets, sortBy = 'relevance') => ({
  type: actionTypes.SEARCH_SUCCESS,
  results,
  facets,
  sortBy,
});
export const searchError = (error) => ({
  type: actionTypes.SEARCH_ERROR,
  error,
});
